// extracted by mini-css-extract-plugin
export default {"subscribed":"ProductButton-module__subscribed--S_FcN"};